// extracted by css-extract-rspack-plugin
export default {"SortDirectionButton":"qY7T2"};